import { render } from "./theme-settings.vue?vue&type=template&id=7b4effd4"
import script from "./theme-settings.vue?vue&type=script&lang=js"
export * from "./theme-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__